import { RowAction } from "@beeldit/core/enums/RowAction.enum";
import { TableAction } from "@beeldit/core/enums/TableAction.enum";
import { FinalTableConfig } from "@beeldit/core/models/FinalTableConfig.interface";
import { Eye, Plus, Trash } from "@phosphor-icons/react";

const tableConfig: FinalTableConfig = {
  index: null,
  actions: [
    {
      name: TableAction.CREATE,
      label: "create_page",
      showLabel: true,
      allowed: true,
      show: true,
      action: null,
      variant: 'primary',
      icon: <Plus size={20} />,
    },
  ],
  rowActions: [
    {
      name: RowAction.DETAILS,
      label: "details",
      icon: <Eye size={20} />,
      allowed: true,
      show: true,
      action: (element: any) => {
        console.log("details", element);
      },
    },
    {
      name: RowAction.DELETE,
      label: "delete",
      icon: <Trash size={20} />,
      allowed: true,
      show: (element: any, user: any) => {
        return element.type === 3;
      },
      action: (element: any) => {
        console.log("delete", element);
      },
    },
  ],
  rowConfiguration: {
    class: (element: any) => {
      return null;
    },
  },
  columns: [
    {
      name: "id",
      label: "#",
      key: "id",
      type: "number",
      show: true,
      sortable: true,
    },
    {
      name: "title",
      label: "title",
      key: "title.es",
      type: "string",
      show: true,
      sortable: true,
    },
  ],
  pagination: {
    enabled: true,
    back: true,
  },
};
const getConfig: any = (functionsAndConfig: any) => {
  const {
    indexFunction,
    initializeFunction,
    prepareRemoveFunction,
    detailsFunction,
    config,
  } = functionsAndConfig;
  tableConfig.actions[0].show = config && config.showCreation;
  tableConfig.actions[0].action = () => initializeFunction();
  tableConfig.index = () => indexFunction();
  tableConfig.rowActions[0].action = (id: any, urlFragment: string) => detailsFunction(id, urlFragment);
  tableConfig.rowActions[1].action = (id: any) => prepareRemoveFunction(id);
  return tableConfig;
};
export default getConfig;
